(function (module) {
    "use strict";

    module.component('forecastNameValueEdit', {
        template: require('./forecastNameValueEditComponent.html'),
        bindings: {
            resolve: '<',
            dismiss: '&',
            close: '&'
        },
        controller: ['$scope', function(this: $TSFixMe, $scope: $TSFixMe) {
            var $ctrl = this;

            $ctrl.$onInit = function () {
                $scope.model = $ctrl.resolve.model;
                $ctrl.options = $ctrl.resolve.options;
            };
            $ctrl.ok = function () {
                $ctrl.close({ $value: {
                    id: $scope.model.id,
                    name: $scope.model.name,
                    value: $scope.model.value,
                    isActive: $scope.model.isActive
                } });
            };

            $ctrl.cancel = function () {
                $ctrl.dismiss({ $value: 'cancel' });
            };
        }]
    })

})(angular.module('topline.modules'));